var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('overlay',{attrs:{"isActive":_vm.showOverlay},on:{"closed":function($event){return _vm.setShowOverlay(false)}}}),_c('section',{staticClass:"container-fluid p-0"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }